import React, { FC } from 'react';

import { KafkaMessage } from '@go-shared/types/kafkaLogs';

import './KafkaLogs.scss';
import { KafkaLog } from './KafkaLog/KafkaLog';

export const KafkaLogs: FC<{ logs: KafkaMessage[] }> = ({ logs }) => {
  return (
    <div className="kafka-logs-wrapper content-minus-logo overflow-y-scroll">
      {logs.map((log, i) => (
        <KafkaLog {...log} key={i} />
      ))}
    </div>
  );
};
